import React,{ useContext, useState } from 'react'
import {
    newNovelMobileContainer,
    videoContainer,
    formContainer,
    NewNovelHeading,
    errorText
} from '../style'
import { Box, Button, Text } from '../../../designSystem'
import VideoPlayer from '../../../components/VideoPlayer'
import { FloatingInput } from '../../../components/FormComponents'
import { handleEventLog, handleNotionOrExternalLink } from '../../../lib/utils'
import { getModuleOrTextAccordingToLocale } from '../helpers'
import { get } from '../../../lib/api'
import BingerInvite from '../../../components/BingerInvite'
import { AccountContext } from '../../../providers/accountProvider'
import useSubCreationTab from '../../../lib/customHooks/useSubCreationTab'
import SubTabs from '../../../components/SubTabs'
import { getImageUrl } from '../../../lib/utils/convertCanvasToImage'
import { uploadFile } from '../../Shows/Novels/CreateNew'

const VideoPlayerCard = ({ referrer, bingerExpVaraint,history }) => {
    const [isBookNameInvalid, setIsBookNameInvalid] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [bookName, setBookName] = useState("")
    const [isBookCreateProcessing, setIsBookCreateProcessing] = useState(false)
    const {user, isUgcUser, isHindiUgcUser } = useContext(AccountContext)
    const { tabSelected, handleTabClick } = useSubCreationTab(history)


    const bookNameChangeHandler = text => {
        if(isBookNameInvalid) {
            setIsBookNameInvalid(false)
            setErrorMessage("")
        }
        setBookName(text)
    }

    const checkTitleValidOrNot = () => {
        if(isBookCreateProcessing) return
        if(!bookName || bookName.trim().length === 0) {
            setIsBookNameInvalid(true)
            setErrorMessage("Enter title")
            return
        }
        if(bookName.trim().length > 70){
            setIsBookNameInvalid(true)
            setErrorMessage("Title shouldn't be more than 70 characters")
            return
        }
        setIsBookNameInvalid(false)
        setIsBookCreateProcessing(true)
        if(isUgcUser || tabSelected === 1){
            get(`/search/novel_search/similar_titles/?query=${bookName}&is_novel=1`).then((res) =>{
                if(res?.results?.length){
                  setIsBookNameInvalid(true)
                  setIsBookCreateProcessing(false)
                  setErrorMessage("Sorry, we have series with similar name")
                }else{
                  createNewNovelHandler()
                }
            })
        }else{
            createNewNovelHandler() 
        }
      }

    const createNewNovelHandler = async () => {
        handleEventLog('create_new_novel','button_click',{
            route : window.location.pathname + window.location.search,button:'create_book'
        }) 
        const coverFile = await getImageUrl(bookName.trim(), user?.fullname)
        uploadFile(coverFile, bookName, referrer, isUgcUser || tabSelected === 1, undefined,tabSelected === 1 ? 'hindi' : 'english')
    }
    return (
        <Box {...newNovelMobileContainer}>
            {!bingerExpVaraint && <Box {...videoContainer}>
              <VideoPlayer
                videoSrc={getModuleOrTextAccordingToLocale(user,'videoTutorialSrc',undefined,tabSelected === 1)} 
                videoType="video/mp4"
                videoAutoPlay={false} 
                videoLoop 
                videoMuted
                isSeries={tabSelected === 1 || isUgcUser}
              />
            </Box>}
            {referrer === 'reader_screen' && bingerExpVaraint && <BingerInvite bingerExpVaraint={bingerExpVaraint} />}
            <Box {...formContainer}>
                <NewNovelHeading>
                    Start Your Journey {" "}
                    {(isUgcUser|| tabSelected === 1)&& <span aria-label="Guide">📘
                        <span 
                            style={{ cursor: 'pointer', color: 'blue', textTransformation: 'underline'}}
                            onClick={() => handleNotionOrExternalLink(getModuleOrTextAccordingToLocale(user,'guideLink',undefined,tabSelected === 1) || 'https://pocketnovel.notion.site/35838ce4579843f196a99e92ed02c2e1?v=f4fe620088cd4b8cae9e2edfa630753c&pvs=4')}
                        >
                            Guide
                        </span>
                    </span>}
                </NewNovelHeading>
                {isHindiUgcUser && <SubTabs selectedIndex={tabSelected} handleTabClick={(index) => handleTabClick(index)}/>}
                <FloatingInput
                    type="text"
                    name="book-name"
                    value={bookName}
                    label={getModuleOrTextAccordingToLocale(user,'label',undefined,tabSelected === 1)}
                    height="48px"
                    padding="4px 8px"
                    fontSize="12px"
                    onChange={text => bookNameChangeHandler(text)}
                />
                {isBookNameInvalid && <Text {...errorText}>{errorMessage}</Text>}
                <Button sizeVariant="M" variant="fillPrimary" mt={8} isLoading={isBookCreateProcessing} width="100%" onClick={checkTitleValidOrNot} disabled={!bookName}>{getModuleOrTextAccordingToLocale(user,'createNewNovelCTAText',undefined,tabSelected === 1)}</Button>
            </Box>
        </Box>
    )
}
export default VideoPlayerCard
